import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';

import { LearnMoreIcon, useResolvedLink } from '@swf/poker';

import { GameType } from '../../../../types/Game';
import type { GameTypeName } from '../../../../types/Game';

import { TXTCLI_How_to_play } from './HowToPlayButton.messages.json';
import styles from './HowToPlayButton.scss';

const GAME_TYPE_RULES_RESOLVER_TAGS: Partial<Record<GameTypeName, ResolverTag>> = {
  [GameType.HoldemSix]: ResolverTag.SaGSixGameRules,
  [GameType.Holdem]: ResolverTag.SaGGameRules
};

interface Props {
  gameType: GameTypeName;
}

const HowToPlayButton: React.FC<Props> = ({ gameType }: { gameType: GameTypeName }) => {
  const howToPlayLink = useResolvedLink(
    GAME_TYPE_RULES_RESOLVER_TAGS[gameType] ?? ResolverTag.SaGGameRules
  );

  return (
    <StarsLink
      href={howToPlayLink}
      className={styles.howToPlayLinkButton}
      target="_blank"
      rel="noreferrer"
    >
      <Translation {...TXTCLI_How_to_play} />
      <LearnMoreIcon />
    </StarsLink>
  );
};

export default HowToPlayButton;
